import React from 'react';
import { EnvelopeIcon, PhoneIcon, MapPinIcon } from '@heroicons/react/24/solid';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-b from-teal-800 to-teal-900 text-white px-6 py-12 mt-10">
      <div className="max-w-[1600px] mx-auto text-center">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 text-sm justify-center items-start text-left">
          <div className="flex items-center gap-3">
            <div className="bg-white/10 rounded-lg p-2">
              <EnvelopeIcon className="h-5 w-5 text-white" />
            </div>
            <a href="mailto:contact@citispring.com" className="hover:text-teal-200 transition-colors">
              contact@citispring.com
            </a>
          </div>

          <div className="flex items-center gap-3">
            <div className="bg-white/10 rounded-lg p-2">
              <PhoneIcon className="h-5 w-5 text-white" />
            </div>
            <a href="tel:+9186967702088" className="hover:text-teal-200 transition-colors">
              +91-86967702088
            </a>
          </div>

          <div className="flex items-start gap-3">
            <div className="bg-white/10 rounded-lg p-2">
              <MapPinIcon className="h-5 w-5 text-white" />
            </div>
            <p className="text-teal-50">
              CC - 100, Street - 233,<br />
              Newtown, Kolkata, India
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-6">
          <p className="text-sm text-teal-100/80">
            &copy; {new Date().getFullYear()} Citispring. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
